import React from 'react'

function StepHeading({heading}) {
    return (
        <>
            <h4>{heading} </h4>
            <hr style={{ borderBottom: "1px Solid var(--hr-color)" }} />
            <br />
        </>
    )
}

export default StepHeading